import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as DeviceManager from '../domain/device-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
// import { GetPartNumberDetails } from '../../types/device';
import { PromiseType } from '../../types';

export type DeviceData = PromiseType<ReturnType<typeof DeviceManager.getPartNumberDetails>>;
type ContextState = Data<DeviceData>;
const Context = React.createContext<ContextState | null>(null);

function useGetPartNumberDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useGetPartNumberDetails must be used within a GetPartNumberProvider');
    }
    return contextState;
}

const GetPartNumberProvider: React.FC<{ siteId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'get-part-number-details',
        id: props.siteId,
        dataFn: React.useCallback(() => DeviceManager.getPartNumberDetails(authHelper, props.siteId), [
            authHelper,
            props.siteId,
        ]),
    });

    const getPartNumberData = dataFromDataset(dataset);

    return <Context.Provider value={getPartNumberData}>{props.children}</Context.Provider>;
};

const TestGetPartNumberProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { GetPartNumberProvider, TestGetPartNumberProvider, useGetPartNumberDetails };
